import { useTranslation } from "@/i18n/translations";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import axios from "axios";
import { API } from "@/App";

export default function LanguageSwitcher() {
  const { lang, setLanguage } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', flag: '🇬🇧', name: 'English' },
    { code: 'ru', flag: '🇷🇺', name: 'Русский' },
    { code: 'fr', flag: '🇫🇷', name: 'Français' },
    { code: 'tr', flag: '🇹🇷', name: 'Türkçe' }
  ];

  const currentLanguage = languages.find(l => l.code === lang);

  const handleLanguageChange = (code) => {
    setLanguage(code);
    setIsOpen(false);
    // Persist to profile so email/Telegram notifications follow the UI language
    if (localStorage.getItem('token')) {
      axios.patch(`${API}/user/language`, { language: code, notification_language: code }).catch(() => {});
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white text-black rounded-lg border-2 border-black hover:bg-gray-100 transition-all font-medium text-sm"
      >
        <span>{currentLanguage?.flag}</span>
        <span>{currentLanguage?.code.toUpperCase()}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Overlay to close dropdown */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown menu */}
          <div className="absolute right-0 mt-2 bg-white border-2 border-black rounded-lg shadow-lg z-20 min-w-[140px]">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`w-full flex items-center gap-2 px-4 py-2 text-left text-black hover:bg-gray-100 transition-colors first:rounded-t-md last:rounded-b-md ${
                  lang === language.code ? 'bg-gray-50 font-bold' : ''
                }`}
                data-testid={`language-${language.code}`}
              >
                <span>{language.flag}</span>
                <span className="text-sm">{language.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
